import AOS from 'aos'
import 'aos/dist/aos.css'
import Swiper, { Autoplay, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"

AOS.init()
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const swiper = new Swiper('.swiper', {
    modules: [Autoplay, Navigation],
    spaceBetween: 30,
    navigation: {
        enabled: true,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        1024: {
            navigation: {
                enabled: true
            },
        }
    }
})

swiper[0].on('slideChange', function () {
    for(let i=0; i < tl1.length; i++ ) {
        if(i == this.activeIndex)
            tl1[i].play()
        else
            tl1[i].pause(0)
    }
})

swiper[1].on('slideChange', function () {
    for(let i=0; i < tl2.length; i++ ) {
        if(i == this.activeIndex)
            tl2[i].play()
        else
            tl2[i].pause(0)
    }
})

const hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
    hamburgers.forEach(function(hamburger) {
        hamburger.addEventListener("click", function() {
            this.classList.toggle("is-active");
            let nav = document.querySelector("header nav")
            nav.classList.toggle("is-active")
        }, false);
    });
}

// 選單
const menuBtns = document.querySelectorAll("header nav ul a[href^='#box']")
menuBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
        e.preventDefault()

        document.querySelector(".hamburger").classList.toggle("is-active")
        document.querySelector("header nav").classList.toggle("is-active")

        const id = this.getAttribute('href')
        const headerH = document.querySelector("header").offsetHeight
        gsap.to(window, {
            duration: 1,
            scrollTo: { y: id, offsetY: headerH },
            ease: "power2"
        })
    })
})

// 
let tl1 = []
tl1[0] = gsap.timeline()
const bg1s = document.querySelectorAll("[data-bg1]")
tl1[0].from( bg1s[0], { width: 0, duration: .8 }, ">" )
tl1[0].from( bg1s[1], { width: 0, duration: .8 }, ">" )
tl1[0].from( bg1s[2], { opacity: 0, duration: .8 }, ">" )
tl1[0].pause(0)

tl1[1] = gsap.timeline()
const bg2s = document.querySelectorAll("[data-bg2]")
tl1[1].from( bg2s[0], { width: 0, duration: .8 }, ">" )
tl1[1].from( bg2s[1], { opacity: 0 , duration: .8 }, ">" )
tl1[1].pause(0)

tl1[2] = gsap.timeline()
const bg3s = document.querySelectorAll("[data-bg3]")
bg3s.forEach(function(bg3) {
    tl1[2].from( bg3, { height: 0, duration: .8 }, ">" )
})
tl1[2].pause(0)


// 
let tl2 = []
tl2[0] = gsap.timeline()
const bg6s = document.querySelectorAll("[data-bg6]")
bg6s.forEach(function(bg6) {
    tl2[0].from( bg6, { opacity: 0, duration: .3 }, "-=25%" )
})
tl2[0].pause(0)

tl2[1] = gsap.timeline()
const bg7s = document.querySelectorAll("[data-bg7]")
bg7s.forEach(function(bg7) {
    tl2[1].from( bg7, { width: 0, duration: .8 }, "-=50%" )
})
tl2[1].pause(0)

tl2[2] = gsap.timeline()
const bg8s = document.querySelectorAll("[data-bg8]")
bg8s.forEach(function(bg8) {
    tl2[2].from( bg8, { height: 0, duration: .8 }, ">" )
})
tl2[2].pause(0)

ScrollTrigger.create({
    id: 'swiper1',
    trigger: "#box1 .swiper",
    start: "top center",
    end: "bottom center",
    scrub: 1,
    onToggle: self => {
        if( self.isActive ) {
            tl1[swiper[0].activeIndex].play()
        } else {
            tl1[swiper[0].activeIndex].pause(0)
        }
    },
    markers: 0
})


ScrollTrigger.create({
    id: 'swiper2',
    trigger: "#box2 .swiper",
    start: "top center",
    end: "bottom center",
    scrub: 1,
    onToggle: self => {
        if( self.isActive ) {
            tl2[swiper[1].activeIndex].play()
        } else {
            tl2[swiper[1].activeIndex].pause(0)
        }
    },
    markers: 0
})

gsap.to( ".mov-water", { y: 800, duration: 2.5, repeat: -1, ease: "power4.in"} )

gsap.fromTo( ".mov-air", { x: -50, y: 80 },
    { x: 850, y: -300, scale: 1, opacity: .5, duration: 12, repeat: -1,  ease: "power2.out"} )

gsap.fromTo( ".mov-car", { x: 150 },
    { x: function(){
        return window.screen.width * -1 - 200
    }, duration: window.screen.width/65, repeat: -1} )

// gsap.fromTo( ".mov-dete", { y: -60 },
//     { y: 10, duration: 2, repeat: -1, yoyo: true,  ease: "bounce.out"} )

const tl = gsap.timeline({
    scrollTrigger: {
        trigger: ".banner",
        start: "top top",
        end: "bottom top",
        markers: 0,
        scrub: 1,
        onToggle: self => console.log("toggled, isActive:", self.isActive)
    }
})
tl.to(".mov-txt2", {
    y: 60
})